import { AccountGroup } from '@galaxy/account-group';
import { Cell } from '@vendasta/uikit';
import { AddressCellComponent } from './address-cell.component';

export class AddressCell implements Cell {
  component = AddressCellComponent;
  constructor(public config: { accountGroupId?: string; accountGroup?: AccountGroup }) {}
}
